import React from "react";
import ItineraryHubPage from "@/components/ItineraryHubPage";
import { HUB_DESIERTO_ATLAS } from "@/lib/itineraryHubs";

export default function DesiertoAtlasHubPage() {
  return <ItineraryHubPage hub={HUB_DESIERTO_ATLAS} />;
}
